import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const TreeRecord = Record({
  children: List(),
  id: null
});

const data = {
  collections: {
    children: "TreeRecord"
  }
};
createFromJS.registerCallback("TreeRecord", createFromJS.createNestedCallback(TreeRecord, data));
